export const POOLING_NOTIFICATIONS_INTERVAL = 5000 // 5 sec
